import React from "react";
import "./Contact.css";
import ResultsSection from "../../components/horizontalbanner/HorizontalBanner";
import TrustedCompanies from "../../components/Companies/Companies";
import ContactForm from "../../components/ContactForm/ContactForm";

const Contact = () => {
  return (
    <div className="contact-page">
      <section className="contact-section">
        <div className="contact-background-glow"></div>

        <ContactForm formSource="Contact Page" />
      </section>

      <ResultsSection />
      <TrustedCompanies />
    </div>
  );
};

export default Contact;